import { styled } from "@mui/material";
import Paper from "@mui/material/Paper";

const WelcomeCard = styled(Paper)(({ theme }) => ({
  boxShadow: "0px 2px 20px 0px #DFC6F2BF",
  borderRadius: "20px",
  width: "420px",
  padding: "30px 20px",
  position: "relative",
  "@media screen and (max-width:600px)": {
    width: "100%",
    borderRadius: "0",
    flexGrow: 1,
  },
  "&::after": {
    content: "''",
    position: "absolute",
    width: "200px",
    height: "200px",
    borderRadius: "50%",
    backgroundColor: "#FAF4FF",
    bottom: "-150px",
    right: "-5%",
    transform: "translateX(5%)",
    zIndex: "-1",
  },
}));

export default WelcomeCard;
